import { useTranslation } from 'react-i18next';
import { Flex, Heading, Button } from '@radix-ui/themes';
import { ToggleGroup } from '../../../../shared/ToggleGroup/ToggleGroup';

const VIEW_TYPES = {
  CALENDAR: 'calendar',
  LIST: 'list',
};

export const CampaignsHeader = ({
  activeView,
  onViewToggle,
  onOpenHighlightModal,
}) => {
  const { t } = useTranslation('campaigns');

  const viewToggleItems = [
    {
      value: VIEW_TYPES.LIST,
      label: t('tableOverview.listView'),
      icon: 'fa-regular fa-list',
    },
    {
      value: VIEW_TYPES.CALENDAR,
      label: t('tableOverview.calendarView'),
      icon: 'fa-regular fa-calendar',
    },
  ];

  return (
    <Flex justify="between" align="center">
      <Heading size="5" weight="bold">
        {t('tableOverview.campaigns')}
      </Heading>
      <Flex gap="3" align="center">
        <ToggleGroup
          type="single"
          items={viewToggleItems}
          value={activeView}
          onValueChange={onViewToggle}
        />
      </Flex>
      <Button size="4" onClick={onOpenHighlightModal}>
        <i className="fa-solid fa-plus" />
        {t('tableOverview.addCampaign')}
      </Button>
    </Flex>
  );
};
